/**
 * user-api account/me — Play On/Off (game_mode) for the current persona.
 * HMAC is signed by the BFF at /proxy/user.
 */

import { dmRequest } from './dmApiClient';

export const USER_PROXY = '/proxy/user';

export async function getAccountMe(accessToken) {
  const res = await dmRequest(USER_PROXY, '/api/v0/account/me', {
    method: 'GET',
    accessToken,
  });
  return res?.data ?? null;
}

export async function setAccountGameMode(accessToken, on) {
  const res = await dmRequest(USER_PROXY, '/api/v0/account/me', {
    method: 'POST',
    accessToken,
    body: { game_mode: on ? 1 : 0 },
  });
  return res?.data ?? null;
}
